import React from 'react';
import PropTypes from 'prop-types';
import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

import { updatePartnerSalaryData, loadIncomeDataDetailOptions } from '../actionCreators';

// material-ui components
import { Tabs, Tab, Grid } from '@mui/material';

import OfferPartnerIncomeDataListComponent from './OfferPartnerIncomeDataListComponent';

class OfferPartnerSalaryDataContainer extends React.PureComponent {
  state = {
    tabIndex: 0,
    editable: false,
    data: this.props.data
  };

  componentDidUpdate(prevProps) {
    if (prevProps.data !== this.props.data) {
      this.setState({ data: this.props.data });
    }
  }

  handleTabChange = (event, tabIndex) => {
    this.setState({ tabIndex, editable: false });
  };

  loadDetails = detailId => {
    return this.props.actions.loadIncomeDataDetailOptions(detailId);
  };

  onEdit = () => {
    this.setState({ editable: true });
  };

  onCancel = () => {
    this.setState({ editable: false, data: this.props.data });
  };

  onSave = async () => {
    var data = {
      ...this.state.data[this.state.tabIndex],
      documentId: this.props.documentId,
      siteId: this.props.siteId,
      partnerId: this.props.partnerId,
      incomeTypeId: this.props.incomeTypeId
    };

    try {
      let event = this.props.onSave ? await this.props.onSave(data) : await this.props.actions.updatePartnerSalaryData(data);
      if (event.ok) {
        this.setState({ editable: false });
      }
    } catch (error) {
      // continue regardless of error
    }
  };

  onChange = (detaildId, value) => {
    let index = this.state.data[this.state.tabIndex].values.findIndex(x => x.incomeTypeDetailId === detaildId);
    let detail = this.state.data[this.state.tabIndex].values[index];
    let newDetail = Object.assign({}, detail, { value });

    let details = [
      ...this.state.data[this.state.tabIndex].values.slice(0, index),
      newDetail,
      ...this.state.data[this.state.tabIndex].values.slice(index + 1)
    ];

    const newData = Object.assign([...this.state.data], {
      [this.state.tabIndex]: { ...this.state.data[this.state.tabIndex], values: details }
    });

    this.setState({ data: newData });
  };

  onPeriodChange = (detaildId, period) => {
    let index = this.state.data[this.state.tabIndex].values.findIndex(x => x.incomeTypeDetailId === detaildId);
    let detail = this.state.data[this.state.tabIndex].values[index];
    let newDetail = Object.assign({}, detail, { period });

    let details = [
      ...this.state.data[this.state.tabIndex].values.slice(0, index),
      newDetail,
      ...this.state.data[this.state.tabIndex].values.slice(index + 1)
    ];

    const newData = Object.assign([...this.state.data], {
      [this.state.tabIndex]: { ...this.state.data[this.state.tabIndex], values: details }
    });

    this.setState({ data: newData });
  };

  getIncomeData = data => {
    if (data && data[this.state.tabIndex]) return data[this.state.tabIndex].values;

    return [];
  };

  checkForSensitiveInfo = data => {
    if (data && data[this.state.tabIndex]) return data[this.state.tabIndex].sensitiveInfo;

    return false;
  };

  render() {
    const { data, editable } = this.state;
    const { fromExternalSource, saving, cardIndex } = this.props;

    return (
      <Grid container spacing={1}>
        <Grid item xs={12} sm={12} md={12}>
          <Tabs value={this.state.tabIndex} indicatorColor='primary' textColor='primary' onChange={this.handleTabChange}>
            {data.map((salary, index) => {
              return <Tab id={'offerPartnerIncomeDataCard_' + cardIndex + '_tab' + index} value={index} key={index} label={salary.name} />;
            })}
          </Tabs>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <OfferPartnerIncomeDataListComponent
            cardIndex={cardIndex}
            loadDetails={this.loadDetails}
            editable={editable}
            onEdit={this.onEdit}
            onCancel={this.onCancel}
            onSave={this.onSave}
            saving={saving}
            onChange={this.onChange}
            data={this.getIncomeData(data)}
            sensitiveInfo={this.checkForSensitiveInfo(data)}
            onPeriodChange={this.onPeriodChange}
            fromExternalSource={fromExternalSource}
          />
        </Grid>
      </Grid>
    );
  }
}

OfferPartnerSalaryDataContainer.propTypes = {
  cardIndex: PropTypes.number,
  actions: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  data: PropTypes.array.isRequired,
  documentId: PropTypes.number.isRequired,
  siteId: PropTypes.number.isRequired,
  partnerId: PropTypes.number.isRequired,
  incomeTypeId: PropTypes.number.isRequired,
  onSave: PropTypes.func,
  saving: PropTypes.bool.isRequired,
  fromExternalSource: PropTypes.bool.isRequired
};

function mapStateToProps() {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ loadIncomeDataDetailOptions, updatePartnerSalaryData }, dispatch),
    dispatch
  };
}

export default compose(connect(mapStateToProps, mapDispatchToProps), withTranslation())(OfferPartnerSalaryDataContainer);
